import React from 'react';
import { Box, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
    Facebook,
    // XIcon,
    LinkedIn,
    // Instagram,
    WhatsApp,
    // YouTube,
    Telegram,
} from '@mui/icons-material';
import XIcon from '@mui/icons-material/X';
const SocialBar = () => {
    const Url = 'https://einbürgerungstest.leeindeutschland.de/';
    const Text =
        'Lassen Sie uns gemeinsam die LiD Prüfung / Einbürgerungstest bestehen! Davon: ';

    const socialLinks = [
        {
            icon: <XIcon />,
            url: `https://twitter.com/intent/tweet?url=${Url}&text=${Text}`,
        },
        {
            icon: <LinkedIn />,
            url: `https://www.linkedin.com/shareArticle?mini=true&url=${Url}`,
        },
        // { icon: <Instagram />, url: `https://instagram.com` }, // Instagram doesn't provide a direct web share link
        {
            icon: <WhatsApp />,
            url: `https://wa.me/?text=${Text}%20${Url}`,
        },
        {
            icon: <Facebook />,
            url: `https://www.facebook.com/sharer/sharer.php?u=${Url}`,
        },
        // { icon: <YouTube />, url: `https://youtube.com` }, // Placeholder for YouTube share
        {
            icon: <Telegram />,
            url: `https://t.me/share/url?url=${Url}&text=${Text}`,
        },
    ];

    return (
        <Box sx={{ p: 1, backgroundColor: '#ffd700' }}>
            <Grid container justifyContent="center" spacing={1}>
                {socialLinks.map((social, index) => (
                    <Grid key={index}>
                        <IconButton
                            href={social.url}
                            target="_blank"
                            color="primary"
                            rel="noopener noreferrer"
                        >
                            {social.icon}
                        </IconButton>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default SocialBar;

// Example usage
<SocialBar
    shareUrl="https://yourwebsite.com"
    shareText="Check out this amazing website!"
/>;
